/* ==========================================================================
   OFF CODE · GROOMING ESSENTIALS
   Reveal-on-scroll, hero depth, header state, mobile menu, Bag drawer
   (Shopify Ajax Cart API), add-to-bag, product gallery, cart page.
   No dependencies. Loaded with `defer` from layout/grooming.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var GE = window.GE || {};
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || GE.moneyFormat || '${{amount}}';
    function fmt(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ==========================================================================
     REVEAL ON SCROLL
     Elements entering together get a small automatic stagger.
     ========================================================================== */
  function initReveal() {
    var targets = $$('.ge-r, .ge-r--mask, .ge-r--arrive, .ge-card, .ge-footer__word');
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      var batch = 0;
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        if (!el.style.getPropertyValue('--d')) el.style.setProperty('--d', (batch * 0.08).toFixed(2) + 's');
        batch++;
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ==========================================================================
     SCROLL: progress bar, header state, hero depth + floor
     ========================================================================== */
  function initScroll() {
    var bar = $('.ge-progress');
    var header = $('.ge-header');
    var floor = $('.ge-stage__floor');
    var items = $$('.ge-stage__item');
    var ticking = false;

    function frame() {
      var y = window.pageYOffset || 0;
      if (header) header.classList.toggle('is-scrolled', y > 8);
      if (!reduce) {
        if (bar) {
          var max = root.scrollHeight - window.innerHeight;
          bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, y / max) : 0) + ')';
        }
        if (floor) floor.style.setProperty('--floor-y', ((y * 0.32) % 88) + 'px');
        if (items.length && y < window.innerHeight * 1.6) {
          for (var i = 0; i < items.length; i++) {
            var d = parseFloat(items[i].getAttribute('data-depth')) || 0;
            items[i].style.transform = 'translate3d(0,' + (-y * d * 0.18).toFixed(2) + 'px,0)';
          }
        }
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(frame); }
    }, { passive: true });
    frame();
  }

  /* ---------- active category in the header while scrolling the collection ---------- */
  function initActiveCats() {
    var groups = $$('[data-ge-group]');
    if (!groups.length || !('IntersectionObserver' in window)) return;
    var links = $$('.ge-cats a[data-type]');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var id = e.target.id;
        links.forEach(function (a) { a.setAttribute('aria-current', a.getAttribute('data-type') === id ? 'true' : 'false'); });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    groups.forEach(function (g) { io.observe(g); });
  }

  /* ==========================================================================
     MOBILE MENU
     ========================================================================== */
  function initMenu() {
    var btn = $('[data-ge-menu]');
    var nav = $('#ge-mnav');
    if (!btn || !nav) return;
    function set(open) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      nav.classList.toggle('is-open', open);
      if (open) nav.removeAttribute('inert'); else nav.setAttribute('inert', '');
      btn.querySelector('[data-label]').textContent = open ? (GE.strings.close || 'Close') : (GE.strings.menu || 'Menu');
    }
    set(false);
    btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
    nav.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav.classList.contains('is-open')) { set(false); btn.focus(); } });
  }

  /* ==========================================================================
     BAG (cart) — drawer + counts
     ========================================================================== */
  var drawer, lastFocus;

  function cartFetch(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var err = new Error(data.description || data.message || 'Error'); err.data = data; throw err; }
        return data;
      });
    });
  }

  function setCount(n) {
    $$('[data-ge-count]').forEach(function (el) {
      if (el.textContent !== String(n)) {
        el.textContent = n;
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
      }
    });
    $$('[data-ge-bag-label]').forEach(function (el) {
      el.setAttribute('aria-label', (GE.strings.bag || 'Bag') + ', ' + n + ' ' + (n === 1 ? (GE.strings.item || 'item') : (GE.strings.items || 'items')));
    });
  }

  function tpl(id) { var t = document.getElementById(id); return t ? t.innerHTML : ''; }

  function lineHTML(item, i) {
    var line = i + 1;
    var parts = String(item.product_title || '').split(' \u2014 ');
    var name = parts[0];
    var sub = '';
    if (item.variant_title && item.variant_title !== 'Default Title') sub = item.variant_title;
    else if (parts.length > 1) sub = parts[parts.length - 1];
    var props = '';
    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        var v = item.properties[k];
        if (v && k.charAt(0) !== '_') props += '<span class="ge-dline__sub">' + esc(k) + ': ' + esc(v) + '</span>';
      });
    }
    var img = '';
    if (item.image) {
      var src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=300';
      img = '<img src="' + esc(src) + '" alt="" loading="lazy" width="300" height="300">';
    }
    return '' +
      '<li class="ge-dline" data-line="' + line + '" style="--i:' + i + '">' +
        '<a class="ge-dline__img" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div class="ge-dline__info">' +
          '<div class="ge-dline__top">' +
            '<div class="ge-dline__names">' +
              '<a class="ge-dline__name" href="' + esc(item.url) + '">' + esc(name) + '</a>' +
              (sub ? '<span class="ge-dline__sub">' + esc(sub) + '</span>' : '') + props +
            '</div>' +
            '<span class="ge-dline__price">' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
          '<div class="ge-dline__ctrl">' +
            '<div class="ge-step">' +
              '<button type="button" data-qty="-1" aria-label="' + esc(GE.strings.decrease || 'Decrease quantity') + '">' + tpl('ge-icon-minus') + '</button>' +
              '<input type="number" min="0" value="' + item.quantity + '" aria-label="' + esc(GE.strings.quantity || 'Quantity') + '" data-qty-input>' +
              '<button type="button" data-qty="1" aria-label="' + esc(GE.strings.increase || 'Increase quantity') + '">' + tpl('ge-icon-plus') + '</button>' +
            '</div>' +
            '<button type="button" class="ge-dline__remove" data-remove aria-label="' + esc((GE.strings.remove || 'Remove') + ' ' + name) + '">' + tpl('ge-icon-x') + '</button>' +
          '</div>' +
        '</div>' +
      '</li>';
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    var body = $('[data-ge-drawer-body]', drawer);
    var checkout = $('[data-ge-checkout]', drawer);
    setCount(cart.item_count);
    $('[data-ge-drawer-count]', drawer).textContent = cart.item_count;
    $('[data-ge-subtotal]', drawer).textContent = formatMoney(cart.total_price);
    if (checkout) checkout.disabled = !cart.item_count;

    if (!cart.item_count) {
      body.classList.add('is-empty');
      body.innerHTML = tpl('ge-empty-tpl');
    } else {
      body.classList.remove('is-empty');
      body.innerHTML = '<ul class="ge-dlines" role="list">' + cart.items.map(lineHTML).join('') + '</ul>';
    }

    var free = $('[data-ge-free]', drawer);
    if (free) {
      var goal = parseInt(free.getAttribute('data-goal'), 10) || 0;
      if (goal > 0) {
        var left = goal - cart.total_price;
        free.hidden = false;
        $('[data-ge-free-text]', free).textContent = left > 0
          ? (GE.strings.freeLeft || 'You are [amount] away from free shipping').replace('[amount]', formatMoney(left))
          : (GE.strings.freeDone || 'Free shipping unlocked');
        $('[data-ge-free-bar]', free).style.transform = 'scaleX(' + Math.min(1, cart.total_price / goal) + ')';
      } else {
        free.hidden = true;
      }
    }
  }

  function refreshCart() { return cartFetch('/cart.js').then(function (cart) { renderDrawer(cart); return cart; }); }

  function openDrawer() {
    if (!drawer) { window.location.href = GE.cartUrl; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    root.classList.add('ge-lock');
    $$('[data-ge-bag-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { var c = $('.ge-drawer__x', drawer); if (c) c.focus(); }, 80);
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('inert', '');
    drawer.setAttribute('aria-hidden', 'true');
    root.classList.remove('ge-lock');
    $$('[data-ge-bag-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function changeLine(lineEl, qty) {
    var line = parseInt(lineEl.getAttribute('data-line'), 10);
    lineEl.classList.add('is-busy');
    return cartFetch('/cart/change.js', { line: line, quantity: Math.max(0, qty) })
      .then(function (cart) {
        if (lineEl.closest('[data-ge-cart-page]')) { window.location.reload(); return; }
        renderDrawer(cart);
      })
      .catch(function (err) {
        lineEl.classList.remove('is-busy');
        window.alert(err.message);
        refreshCart();
      });
  }

  function bindLineControls(scope) {
    scope.addEventListener('click', function (e) {
      var lineEl = e.target.closest('.ge-line, .ge-dline');
      if (!lineEl) return;
      var step = e.target.closest('[data-qty]');
      if (step) {
        var input = $('[data-qty-input]', lineEl);
        changeLine(lineEl, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty'), 10));
      } else if (e.target.closest('[data-remove]')) {
        e.preventDefault();
        changeLine(lineEl, 0);
      }
    });
    scope.addEventListener('change', function (e) {
      if (!e.target.matches('[data-qty-input]')) return;
      var lineEl = e.target.closest('.ge-line, .ge-dline');
      if (lineEl) changeLine(lineEl, parseInt(e.target.value, 10) || 0);
    });
  }

  function initBag() {
    drawer = $('#ge-drawer');
    if (drawer) {
      drawer.setAttribute('inert', '');
      bindLineControls(drawer);
      $$('[data-ge-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', closeDrawer); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
    }
    $$('[data-ge-bag-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!drawer || document.querySelector('[data-ge-cart-page]')) return; // on the cart page the link just navigates
        e.preventDefault();
        refreshCart().catch(function () {});
        openDrawer();
      });
    });
    var page = $('[data-ge-cart-page]');
    if (page) bindLineControls(page);

    // keep the count honest after back/forward cache restores
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart().catch(function () {}); });
  }

  /* ---------- add to bag ---------- */
  function initAddForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-ge-add]');
      if (!form || !window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = $('[type="submit"]', form);
      var label = btn ? $('[data-label]', btn) : null;
      var original = label ? label.textContent : '';
      var error = $('[data-ge-error]', form);
      if (error) error.textContent = '';
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      if (label) label.textContent = GE.strings.adding || 'Adding';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form),
        credentials: 'same-origin'
      })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message); return d; }); })
        .then(function () { return refreshCart(); })
        .then(function () {
          if (label) label.textContent = GE.strings.added || 'Added';
          openDrawer();
          setTimeout(function () { if (label) label.textContent = original; }, 1800);
        })
        .catch(function (err) {
          if (label) label.textContent = original;
          if (error) error.textContent = err.message || GE.strings.error || 'Something went wrong';
          else window.alert(err.message);
        })
        .then(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
    });
  }

  /* ==========================================================================
     PRODUCT PAGE
     ========================================================================== */
  function initQtySteppers() {
    $$('[data-ge-stepper]').forEach(function (wrap) {
      var input = $('input', wrap);
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-step]');
        if (!b) return;
        var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10);
        input.value = Math.max(1, v);
      });
    });
  }

  function initGallery() {
    $$('[data-ge-gallery]').forEach(function (g) {
      var track = $('.ge-gallery__track', g);
      var thumbs = $$('.ge-gallery__thumbs button', g);
      if (!track || !thumbs.length) return;
      function mark(i) { thumbs.forEach(function (t, j) { t.setAttribute('aria-current', i === j ? 'true' : 'false'); }); }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          track.scrollTo({ left: track.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' });
          mark(i);
        });
      });
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
      }, { passive: true });
    });
  }

  function initVariants() {
    $$('[data-ge-variant-select]').forEach(function (sel) {
      var form = sel.closest('form');
      var price = $('[data-ge-price]');
      var btn = form ? $('[type="submit"]', form) : null;
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (price && opt.getAttribute('data-price')) price.innerHTML = opt.getAttribute('data-price');
        if (btn) {
          var available = opt.getAttribute('data-available') === 'true';
          btn.disabled = !available;
          var label = $('[data-label]', btn);
          if (label) label.textContent = available ? (GE.strings.add || 'Add to bag') : (GE.strings.soldOut || 'Sold out');
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', sel.value);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  function initBuybar() {
    var bar = $('.ge-buybar');
    var anchor = $('[data-ge-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    // live directly under <body> so no animated/transformed ancestor can trap position: fixed
    if (bar.parentNode !== document.body) document.body.appendChild(bar);
    // visible only between "scrolled past the main Add to bag" and "the next block with its own buttons"
    var end = $('[data-ge-buy-end]') || $('.ge-footer');
    var pastForm = false, atEnd = false;
    function update() { bar.classList.toggle('is-visible', pastForm && !atEnd); }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { pastForm = !e.isIntersecting && e.boundingClientRect.top < 0; });
      update();
    }).observe(anchor);
    if (end) new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { atEnd = e.isIntersecting || e.boundingClientRect.top < 0; });
      update();
    }, { rootMargin: '0px 0px -60px 0px' }).observe(end);
  }

  /* ==========================================================================
     FOOTER WORDMARK — scale the word so it spans the full width, edge to edge
     ========================================================================== */
  function initWordmark() {
    var words = $$('[data-ge-fit]');
    if (!words.length) return;
    function fit() {
      words.forEach(function (el) {
        var inner = el.firstElementChild;
        if (!inner) return;
        var box = el.clientWidth - parseFloat(getComputedStyle(el).paddingLeft) - parseFloat(getComputedStyle(el).paddingRight);
        inner.style.fontSize = '100px';
        var w = inner.scrollWidth;
        if (w > 0 && box > 0) el.style.setProperty('--ge-word-size', (100 * box / w).toFixed(2) + 'px');
        inner.style.fontSize = '';
      });
    }
    fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(document.body);
    else window.addEventListener('resize', fit);
  }

  /* ==========================================================================
     SEARCH — overlay with live results (Shopify predictive search),
     filtered to products of the Grooming Essentials line.
     ========================================================================== */
  function initSearch() {
    var btn = $('[data-ge-search-open]');
    var box = $('#ge-search');
    if (!btn || !box) return;
    var input = $('input[type="search"]', box);
    var results = $('[data-ge-search-results]', box);
    var hint = results ? results.innerHTML : '';
    var line = GE.lineHandles || [];
    var timer, ctrl, lastFocus;

    function set(open) {
      box.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      box.setAttribute('aria-hidden', open ? 'false' : 'true');
      root.classList.toggle('ge-lock', open);
      if (open) {
        lastFocus = document.activeElement;
        box.removeAttribute('inert');
        setTimeout(function () { input && input.focus(); }, 80);
      } else {
        box.setAttribute('inert', '');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
    }

    function card(p) {
      var img = p.image ? '<img src="' + esc(p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=240') + '" alt="" width="240" height="240" loading="lazy">' : '';
      var parts = String(p.title || '').split(' \u2014 ');
      var price = p.price != null ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '';
      return '<li><a class="ge-sresult" href="' + esc(p.url) + '">' +
        '<span class="ge-sresult__img">' + img + '</span>' +
        '<span class="ge-sresult__info"><span class="ge-sresult__name">' + esc(parts[0]) + '</span>' +
        (parts[1] ? '<span class="ge-sresult__sub">' + esc(parts[1]) + '</span>' : '') + '</span>' +
        '<span class="ge-sresult__price">' + price + '</span></a></li>';
    }

    function search(q) {
      if (ctrl && ctrl.abort) ctrl.abort();
      if (!q) { results.innerHTML = hint; results.classList.remove('is-loading'); return; }
      ctrl = window.AbortController ? new AbortController() : null;
      results.classList.add('is-loading');
      var url = (GE.suggestUrl || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag';
      fetch(url, { headers: { 'Accept': 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var list = (((data || {}).resources || {}).results || {}).products || [];
          if (line.length) list = list.filter(function (p) { return line.indexOf(p.handle) > -1; });
          var all = (GE.searchUrl || '/search') + '?view=grooming&type=product&options[prefix]=last&q=' + encodeURIComponent(q);
          if (!list.length) {
            results.innerHTML = '<p class="ge-search__hint">Nothing in the line matches \u201c' + esc(q) + '\u201d.</p>';
          } else {
            results.innerHTML = '<ul class="ge-sresults" role="list">' + list.slice(0, 6).map(card).join('') + '</ul>' +
              '<a class="ge-pill ge-search__all" href="' + esc(all) + '"><span>View all results</span><span class="ge-pill__arrow">' + tpl('ge-icon-arrow') + '</span></a>';
          }
          results.classList.remove('is-loading');
        })
        .catch(function (err) { if (!err || err.name !== 'AbortError') results.classList.remove('is-loading'); });
    }

    box.setAttribute('inert', '');
    btn.addEventListener('click', function (e) { e.preventDefault(); set(!box.classList.contains('is-open')); });
    $$('[data-ge-search-close]', box).forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.classList.contains('is-open')) set(false);
      if ((e.key === '/' || (e.key === 'k' && (e.metaKey || e.ctrlKey))) && !box.classList.contains('is-open') &&
          !/input|textarea|select/i.test((document.activeElement || {}).tagName || '')) { e.preventDefault(); set(true); }
    });
    if (input) input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      timer = setTimeout(function () { search(q); }, 180);
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    initReveal();
    initScroll();
    initActiveCats();
    initMenu();
    initBag();
    initAddForms();
    initQtySteppers();
    initGallery();
    initVariants();
    initBuybar();
    initWordmark();
    initSearch();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  GE.openBag = openDrawer;
  GE.refreshCart = refreshCart;
  GE.formatMoney = formatMoney;
  window.GE = GE;
})();
